import {useUpdateDatasetInfo} from "api/api-hooks/datasets-hooks";
import {BaseDatasetDTO} from "api/model/dataset/BaseDatasetDTO";
import {DatasetInfo} from "api/model/dataset/DatasetInfo";
import {easasAlert} from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import React, {useEffect, useState} from "react";
import { T } from "services/lang/LanguageService";

interface IFindAndReplaceProps {
    selectedDatasets: DatasetInfo[],
    setSelectedDatasets: (arr: Array<DatasetInfo>) => void
    setFindAndReplaceDialogVisibility: (value: boolean) => void
}

const FindAndReplaceDialog = ({
                                  selectedDatasets,
                                  setFindAndReplaceDialogVisibility,
                                  setSelectedDatasets
                              }: IFindAndReplaceProps) => {
    const [datasetsToUpdate, setDatasetsToUpdate] = useState<(DatasetInfo | BaseDatasetDTO)[]>([]);
    const [findValue, setFindValue] = useState("");
    const [replaceValue, setReplaceValue] = useState("");


    useEffect(() => {
        const modifiedDatasets: DatasetInfo[] = [];
        selectedDatasets.map((dataset) => {
            if (findValue.length > 0 && dataset.title?.includes(findValue)) {
                const modifiedTitle = dataset.title.replace(findValue, replaceValue);
                return modifiedDatasets.push({
                    ...dataset,
                    title: modifiedTitle,
                });
            }
            return null
        });

        setDatasetsToUpdate(modifiedDatasets);
    }, [findValue, replaceValue]);

    const {mutateAsync} = useUpdateDatasetInfo();

    const saveChangesHandler = async () => {
        try {
            if (datasetsToUpdate.length === 0) {
                easasAlert({
                  summary: T("alert.no-changes-detected"),
                  detail: T("alert.please-make-changes-before-saving"),
                  severity: "warn",
                });
                return;
            }

            const results = await Promise.allSettled(datasetsToUpdate.map(async (dataset) => {
                    return mutateAsync(dataset as BaseDatasetDTO);
                })
            );

            const successFullMutations = results.filter((result) => result.status === "fulfilled");
            const failedMutations = results.filter((result) => result.status === "rejected");

            if (successFullMutations.length === results.length) {
                easasAlert({
                  summary: T("alert.success"),
                  detail: T("alert.all-changes-were-saved-successfully"),
                  severity: "success",
                });
            } else {
                easasAlert({
                  summary: T("alert.error"),
                  detail: T("error.datasets-failed-to-update", {count: failedMutations.length}),
                  severity: "error",
                });
            }
        } catch (e) {
            console.log("Error updating datasets", e);
            easasAlert({
              summary: T("alert.error"),
              detail: T("error.an-error-occurred-while-updating-datasets"),
              severity: "error",
            });
        }

        setFindAndReplaceDialogVisibility(false);
        setSelectedDatasets([]);
    };


    return (
        <div className="flex flex-column gap-3">
            <div className="flex flex-column">
                <label htmlFor="find"> {T("action.find")}:</label>
                <InputText className="find" value={findValue} onChange={e => setFindValue(e.target.value)}/>
            </div>
            <div className="flex flex-column">
                <label htmlFor="replaceWith"> {T("label.replace-with")}:</label>
                <InputText className="replaceWith" value={replaceValue}
                           onChange={e => setReplaceValue(e.target.value)}/>
            </div>
            <div>{T("message.count-datasets-will-be-affected", {count: datasetsToUpdate.length})}</div>
            <div className="buttons flex gap-2 mt-2">
                <Button
                    label={T("action.save")}
                    icon="pi pi-check"
                    onClick={saveChangesHandler}
                    className="p-button-success"
                />
                <Button
                    label={T("word.cancel")}
                    icon="pi pi-times"
                    onClick={() => setFindAndReplaceDialogVisibility(false)}
                    className="p-button-danger"
                />

            </div>
        </div>
    );
};

export default FindAndReplaceDialog;